import moment from 'moment-timezone';
import { Organization } from '../types/api';
import { HomeState, HomeActionTypes } from '../types/home';
import { ResourceStatus } from '../types/resource';
import { Filter } from '../types/filters';
import { SenseiApi } from '../utils/api';

import { DispatchType } from '../types/rx-actions';

export async function fetchHomeOrganizationSearchResults(
  dispatch: DispatchType,
  jwtToken: string,
  search: string,
) {
  dispatch({ type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_START });

  let organizations;
  try {
    organizations = await SenseiApi.organizationList(jwtToken, { search });
  } catch (error) {
    dispatch({
      type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: HomeActionTypes.HOME_LOAD_ORGANIZATIONS_COMPLETE,
    organizations,
  });
}

export async function fetchHomeDpuSearchResults(
  dispatch: DispatchType,
  jwtToken: string,
  search: string,
) {
  dispatch({ type: HomeActionTypes.HOME_LOAD_DPUS_START });

  let searchResults;
  try {
    searchResults = await SenseiApi.search(jwtToken, search);
  } catch (error) {
    dispatch({
      type: HomeActionTypes.HOME_LOAD_DPUS_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: HomeActionTypes.HOME_LOAD_DPUS_COMPLETE,
    dpus: searchResults.results
      .filter((i) => i.resource_name === 'units')
      .map((i) => ({
        name: i.result.name,
        organizationId: i.result.organization_id,
        organizationName: i.result.organization_name,
        id: i.result.id,
        hrefId: i.result.href_id,
      })),
  });
}
